import { useDispatch } from 'react-redux';
import { useMutation } from '@tanstack/react-query';
import { showLoading, closeLoading } from '../../Reducer/LoadingReducer';

const ResolveApiErrorMessage = (error, response) => {
  if (response) {
    return (
      response.message ||
      response.Message ||
      '요청 처리에 실패했습니다.'
    );
  }
  const data = error?.response?.data;
  if (typeof data === 'string' && data.trim()) return data.trim();
  if (data?.message) return data.message;
  if (data?.Message) return data.Message;
  if (error?.errorInfo?.originalMessage) return error.errorInfo.originalMessage;
  if (error?.errorInfo?.userMessage) return error.errorInfo.userMessage;
  return error?.message || '요청 처리에 실패했습니다.';
};

const useDeleteMutation = (mutationFn, options = {}) => {
  const dispatch = useDispatch();

  const mutation = useMutation({
    mutationFn: async (vars) => {
      try {
        return await mutationFn(vars);
      } catch (error) {
        const err = new Error(ResolveApiErrorMessage(error));
        err.response = error?.response;
        throw err;
      }
    },

    onMutate: async (vars) => {
      dispatch(showLoading());
      await options.onMutate?.(vars);
    },

    onSuccess: (response, vars, context) => {
      if (
        response?.severity === 'error' ||
        response?.isSuccess === false ||
        response?.IsSuccess === false
      ) {
        const err = new Error(ResolveApiErrorMessage(null, response));
        err.response = response;
        options.onError?.(err, vars, context);
        throw err;
      }

      options.onSuccess?.(response, vars, context);
      return response;
    },

    onError: (error, vars, context) => {
      const err = new Error(ResolveApiErrorMessage(error));
      err.response = error?.response;
      options.onError?.(err, vars, context);
    },

    onSettled: (data, error, vars, context) => {
      dispatch(closeLoading());
      options.onSettled?.(data, error, vars, context);
    },
  });

  const run = (vars) => mutation.mutate(vars);
  const runAsync = (vars) => mutation.mutateAsync(vars);

  return { ...mutation, run, runAsync };
};

export default useDeleteMutation;
